import React, { useMemo, Fragment, ReactElement } from 'react';
import Table from '../../../../components/table/table.component';
import TableHead from '../../../../components/table-head/table-head.component';
import TableBody from '../../../../components/table-body/table-body.component';
import TableRow from '../../../../components/table-row/table-row.component';
import TableCell from '../../../../components/table-cell/table-cell.component';
import FieldSelect from '../../../../components/field-select/field-select.component';
import FormFieldText from '../../../../components/form-field-text/form-field-text.component';
import MenuItemList from '../../../../components/menu-item-list/menu-item-list.component';
import FormService from '../../../../services/form-service';

const SettingsAccountRejectReasonList: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isEditMode,
    formPrefix,
    accountRejectReasonListData,
    rejectReasonList,
  } = props;

  const menuItemRejectReasonList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemValueKey: 'name',
    optionList: rejectReasonList,
  }), [rejectReasonList]);

  const tableAccountRejectReasonFields: TableField[] = useMemo((): TableField[] => [
    {
      id: 1,
      name: 'rejectReason.title',
      title: 'Default Reason Name',
      component: (accountRejectReasonItem: AccountDealRejectReason): ReactElement => {
        const formKeyAccountRejectReason: string = FormService.getIndexedFormFieldKey(
          accountRejectReasonItem.rejectReason.id,
        );

        return (
          <TableCell isText>
            {
              isEditMode ? (
                <FieldSelect
                  isPlain
                  isBordered
                  isDisabled
                  withNoBorders
                  id={`${formPrefix}[${formKeyAccountRejectReason}].rejectReason`}
                  value={accountRejectReasonItem.rejectReason.name}
                >
                  {menuItemRejectReasonList}
                </FieldSelect>
              ) : (accountRejectReasonItem.rejectReason && accountRejectReasonItem.rejectReason.title)
            }
          </TableCell>
        );
      },
    },
    {
      id: 2,
      name: 'title',
      title: 'Account Reason Name',
      component: (accountRejectReasonItem: AccountDealRejectReason): ReactElement => {
        const formKeyAccountRejectReason: string = FormService.getIndexedFormFieldKey(
          accountRejectReasonItem.rejectReason.id,
        );

        return (
          <TableCell isText>
            {
              isEditMode ? (
                <FormFieldText
                  isBordered
                  placeholder="Not Used"
                  name={`${formPrefix}[${formKeyAccountRejectReason}].title`}
                />
              ) : accountRejectReasonItem.title
            }
          </TableCell>
        );
      },
    },
  ], [isEditMode]);

  return (
    <Table>
      <TableHead isSubHeader>
        <TableRow>
          {
            tableAccountRejectReasonFields.map((tableField: TableField): ReactElement => (
              <TableCell key={tableField.id}>
                {tableField.title}
              </TableCell>
            ))
          }
        </TableRow>
      </TableHead>
      <TableBody isPlain withZebraRows withHeaderColumn>
        {
          rejectReasonList.map((rejectReasonItem: StatusChangeReason): ReactElement => {
            const accountRejectReason: AccountDealRejectReason = accountRejectReasonListData.find((
              accountRejectReasonItem: AccountDealRejectReason,
            ): boolean => (
              accountRejectReasonItem.rejectReason.name === rejectReasonItem.name
            ));

            return (accountRejectReason || isEditMode) && (
              <TableRow key={rejectReasonItem.id}>
                {
                  tableAccountRejectReasonFields.map((tableField: TableField): ReactElement | boolean => (
                    !!tableField.component && (
                      <Fragment key={tableField.id}>
                        {
                          tableField.component(accountRejectReason || {
                            rejectReason: rejectReasonItem,
                          })
                        }
                      </Fragment>
                    )
                  ))
                }
              </TableRow>
            );
          })
        }
      </TableBody>
    </Table>
  );
});

export default SettingsAccountRejectReasonList;
